import { getBlobUrl } from '../../../helpers/getBlobUrl';
import useAttachmentsByName from '../api/queris/useAttachmentsByName';

const useGetAttachmentUrl = () => {
  const { mutateAsync: fetchAttachmentData } = useAttachmentsByName();

  const getAttachmentUrl =
    ({ transportId }) =>
    async (data) => {
      const fileName = typeof data === 'string' ? data : data.fileName;
      const fileExtension = fileName.split('.').pop();

      const attachData = await fetchAttachmentData({
        transportId,
        fileName,
      });

      const url = getBlobUrl(attachData, fileExtension);

      return url;
    };

  return getAttachmentUrl;
};

export default useGetAttachmentUrl;
